import { Component } from '@theme/component';

/**
 * Controller-Komponente für das gesetzliche Widerrufsformular nach § 356a BGB.
 *
 * Verwaltet den Absendestatus und verhindert mehrfache Klicks auf den Absende-Button.
 *
 * @extends {Component}
 */
class WithdrawalFormComponent extends Component {
  // Definition der benötigten DOM-Referenzen innerhalb des Custom Elements
  requiredRefs = ['submitBtn'];

  connectedCallback() {
    super.connectedCallback();
    this.form = this.querySelector('form');
    
    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }

  /**
   * Behandelt das Absenden des Formulars.
   *
   * @param {SubmitEvent} event
   */
  handleSubmit(event) {
    // Button deaktivieren und Text anpassen, um mehrfache Übermittlungen zu verhindern
    this.refs.submitBtn.setAttribute('disabled', 'true');
    this.refs.submitBtn.textContent = 'Wird übermittelt...';
  }
}

// Registrierung des Custom Elements im Window-Scope
customElements.define('withdrawal-form-component', WithdrawalFormComponent);
